import { User } from '@sm-dashboard/types';

import jwt from 'jwt-decode';

export function getUser(): User | undefined {
  const token = localStorage.getItem('token');

  if (!token) return;
  const user: User = jwt(token);

  return user;
}
